// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__3GPDd","paramInput":"JobSimulator_paramInput__2VNgd","input":"JobSimulator_input__LxukS"};